module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAABEklEQVQ4jX3Tvy4FQRQG8N/+oeCWCg/gITyBUOpEd0s1tSAhcoXiFjdeQKg0PIDKM3gMNBKJXcXO5q4xc7/kZM/unP3mO3O+KWazWYUfi1HlFmo02MYeVqL1Fk+4Q5kjaDHGLl5RRDWjRdLqgcQXbGXqhm2Ww016Wa15n2UUla7NMY5C3sQKhohb6DdYwyTk1+FZpAhyE7nCB26xijOUKYINnGA5+t7gG584xTumKYI6yI0JWnyZtzjqi2O86XyRwj52cIMLlClzVImAA52hznEYlBRJdyVQYAmXOA7v5bCFwvz0U1OoMA35HyP1BA02ce+/D56D9OSFqsMPD7qLtK477V5Vq5t5FnWQ9Bgih+x1/gWe7i/uzEAlAwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/logout.png
// module id = qOCf
// module chunks = 3